import * as React from 'react'
import { websiteCastingWidgetPluginComputePromotionalCode } from '../../../../services/models/website-casting-widgets.service'
import { StoreProps } from '../../../../services/stores/casting.store'
import { currencyFormat, currencyWrapTaxNotice } from '../../../../services/utils/currency.service'
import { errorWrapInHandler } from '../../../../services/utils/errors.service'
import { I18nService } from '../../../../services/utils/i18n.service'
import AsyncButtonComponent from '../../../shared/async-button.component'
import ErrorBoxComponent from '../../../shared/error-box.component'

const i18nScoped = new I18nService(require('./casting-promotional-code-picker.component.yml'))

export default function CastingPromotionalCodePickerComponent ({ store, data: { market, promotionalCode, offeredService, castingType, city } }: StoreProps) {
  const [inputCode, setInputCode] = React.useState('')
  const [errors, setErrors] = React.useState<string[]>([])

  const checkPromoCode = React.useMemo(() => {
    return errorWrapInHandler(async () => {
      const promotionalCode = await websiteCastingWidgetPluginComputePromotionalCode(market, inputCode, { service_id: offeredService.id, casting_type: castingType, customer_id: store.data.customer?.id, city: city?.city, zipcode: city?.postalCode })
      store.setPromotionalCode(promotionalCode)
      return true
    }, setErrors)
  }, [castingType, inputCode, offeredService?.id, store, market, city?.city, city?.postalCode])

  if (promotionalCode) {
    return <div className="u-pan u-man u-mbs u-txtCenter" id="js-test-promo-code-container">
    <div className="cards cards-item u-man">
      <button type="button" className="cards-close cards-no-background" onClick={ () => store.setPromotionalCode(null) }></button>
      <p className="cards-title u-man">{ promotionalCode.code }</p>
      <span className="cards-reduction u-man u-mts u-txtClr1">
        { i18nScoped.t('reduction', { amount: promotionalCode.reduction_type === 'percentage' ? (promotionalCode.value + ' %') : currencyWrapTaxNotice(currencyFormat(market.currency, promotionalCode.value.toFixed(2)), promotionalCode.vat_included) }) }
      </span>

      { promotionalCode.max_events_per_service_delivery && <p className="cards-reduction u-man u-mts u-txtClr1">
        { i18nScoped.t('number_of_valid_recurrences', { count: promotionalCode.max_events_per_service_delivery }) }
      </p> }
    </div>
  </div>
  }

  return <div className="u-mtm u-mbm">
    <div style={{ height: 86 }}>
      <p className="castingStep-desc paragraph--desc">
        <strong>{ i18nScoped.t('have_code') }</strong>
      </p>

      <div className="form u-mbn" style={{ display: 'flex' }}>
        <input
          id="js-test-promo-code-input"
          className="string required w-100"
          placeholder={ i18nScoped.t('enter_code') }
          value={ inputCode ?? '' }
          onChange={ event => setInputCode(event.target.value) }
          type="text" />

        <AsyncButtonComponent
          id="js-test-promo-code-apply"
          children={ i18nScoped.t('apply') }
          className="button--promo-code buttonNeutral u-mls"
          disabled={ !inputCode }
          onClick={ checkPromoCode } />
      </div>
    </div>

    <ErrorBoxComponent fullMessages={ errors } disableAutoScroll />
  </div>
}
